export const resetExitIntent = () => {
  sessionStorage.removeItem("loyalty_exit_intent_shown")
}

export const hasExitIntentBeenShown = () => {
  const shown = sessionStorage.getItem("loyalty_exit_intent_shown") === "true"
  return shown
}

export const simulateExitIntent = () => {
  const event = new MouseEvent("mousemove", {
    clientX: 100,
    clientY: 5,
    bubbles: true,
    cancelable: true,
  })

  document.dispatchEvent(event)
}

export const testExitIntent = () => {
  resetExitIntent()
  simulateExitIntent()
}

if (typeof window !== "undefined") {
  window.testExitIntent = testExitIntent
  window.resetExitIntent = resetExitIntent
  window.simulateExitIntent = simulateExitIntent
  window.hasExitIntentBeenShown = hasExitIntentBeenShown
}
